(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Dropdowns: close on Escape and on a click outside. Native <details> handles
  // the rest, including keyboard opening.
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-dropdown][open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-dropdown][open]').forEach((dropdown) => {
      dropdown.open = false;
      dropdown.querySelector('summary')?.focus();
    });
  });

  // Calm mode. The choice is the visitor's and is remembered between visits.
  (() => {
    const root = document.documentElement;
    const buttons = document.querySelectorAll('[data-calm-toggle]');
    if (!buttons.length) return;

    const sync = () => {
      const on = root.getAttribute('data-calm') === 'on';
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(on)));
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const next = root.getAttribute('data-calm') === 'on' ? 'off' : 'on';
        root.setAttribute('data-calm', next);
        try {
          localStorage.setItem('linden:calm', next);
        } catch (e) {
          // Storage can be blocked; the toggle still works for this page view.
        }
        sync();

        const region = document.getElementById('live-region');
        if (region) {
          region.textContent = button.dataset[next === 'on' ? 'labelOn' : 'labelOff'] || '';
        }
      });
    });

    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const load = () => {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((markup) => {
            const parsed = new DOMParser().parseFromString(markup, 'text/html');
            const fresh = parsed.querySelector('.shopify-section');
            if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
          })
          .catch(() => {
            // No recommendations is a fine outcome; leave the slot empty.
          });
      };

      // Only fetch once the section is close to the viewport.
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries, obs) => {
            if (entries[0].isIntersecting) {
              obs.disconnect();
              load();
            }
          },
          { rootMargin: '400px' }
        );
        observer.observe(this);
      } else {
        load();
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      this.offset = Number(this.dataset.offset) || 700;
      this.shown = false;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.shown || window.scrollY < this.offset) return;

      this.shown = true;
      this.hidden = false;
      document.body.classList.add('has-sticky-bar');

      // Next frame, so the transition runs from the off-screen position.
      requestAnimationFrame(() => this.classList.add('sticky-bar--visible'));

      window.removeEventListener('scroll', this.onScroll);
    }
  }

  if (!customElements.get('sticky-buy-bar')) {
    customElements.define('sticky-buy-bar', StickyBuyBar);
  }

  } catch(e) { console.error(e); }
})();
})();
